import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Utils} from "@amlCore/utils";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {RegistriesService} from "../../service";
import {InagentInfo} from "../../model/inagentInfo.model";


@Component({
  selector: 'app-registry-inagent-form',
  templateUrl: './inagentForm.component.html'
})
export class InagentFormComponent implements OnInit {
  @Input() id = null;
  @Input() hideGoBackBtn = false;
  @Input() isModal = false;
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();

  item: InagentInfo;
  subjectId = null;

  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.id) {
      this.startLoading.emit(true);
      this.startLoading.complete();
      this.loadSubject(this.id);
    } else {
      this.route.params.subscribe(params => {
        Utils.scrollTopSmooth();
        this.id = params.id;
        this.loadSubject(this.id);
      });
    }
  }

  loadSubject(id) {
    this.regSrv.getInagentById(id).subscribe(data => {
      this.item = data;
      this.finishLoading.emit(false);
      this.finishLoading.complete();
    });
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }
}
